const isNumber = (number) => (!isNaN(number) && (typeof number === 'number') && number !== Infinity && number !== -Infinity);

export default isNumber